import React from 'react';
import { Navigate } from 'react-router-dom';
// Dashboard
import Dashboard from '../pages/Dashboard/Dashboard';
import HRDashboard from '../pages/HRDashboard/HRDashboard';
// Timesheet
import TimeSheet from '../pages/Timesheet/TimeSheet';
// Detailed Timesheet
import DetailedTimesheet from '../pages/Timesheet/DetailedTimesheet/DetailedTimesheet';

// Profile
import Profile from '../pages/Profile/Profile';

// Leaves
import { Approvals } from '../pages/LeaveInfo';

// Admin
import {
  ApplicationServices,
  EncryptPassword,
  Role,
  UserManagement,
  ReassignApprovals,
} from '../pages/Admin';

// Bonus
import Bonus from '../pages/Bonus/Bonus';

// Activity
import Activity from '../pages/Activity/Activity';

// Enquiry
import {
  LeaveEnquiry,
  OvertimeEnquiry,
  LoanEnquiry,
  ExpenseEnquiry,
  TravelEnquiry,
  WFHEnquiry,
  CompOffEnquiry,
} from '../pages/Enquiry';

// Login
import Login from '../pages/Authentication/Login';
import Login2FA from '../pages/Authentication/Login2FA';

// Expense Claims
import {
  EmployeeExpenseClaims,
  EmployeeExpenseClaimsDetail,
  ProcessExpenseClaim,
} from '../pages/ExpenseClaims';

// Apply Leaves
import {
  ApplyLeave,
  ApplyCompOff,
  ApplyWFH,
  ApplyOverTime,
  ApplyLoan,
} from '../pages/Leaves';

// Holiday
import { Planning, Analysis } from '../pages/Holiday';

// Travel Request
import {
  PendingTravelRequest,
  NewTravelRequest,
  TravelRequestOptions,
  TravelRequestApproval,
} from '../pages/Travel';

// Timesheet Statistics
import TimesheetStatistic from '../pages/TimesheetStatistics/TimesheetStatistics';

// FAQ
import FAQ from '../pages/FAQ/FAQ';

// Tickets
import {
  TicketDetails,
  TicketListing,
  HRTicketDetails,
  HRTicketListing,
} from '../pages/Tickets';

// HR Dashboard
import HRApprovals from '../pages/HRApprovals/HRApprovals';
// HR Travel Request
import {
  RiskCountry,
  ProcessRequest,
  HRTravelEnquiry,
  BookingAgent,
} from '../pages/HRTravelRequest';
// HR Expense Claims
import { ClaimEnquiry, ProcessClaim } from '../pages/HRExpenseClaims';
// HR Ticketing
import { HRResolveTicket } from '../pages/HRTickets';
// Performance
import Performance from '../pages/Performance/Performance';
import Calibration from '../pages/Calibration/Calibration';
import EmployeePerformance from '../pages/EmployeePerformance/EmployeePerformance';
import ProtectedRoute from './ProtectedRoute';
import PerformanceCalibration from '../pages/Calibration/PerformanceCalibration';
import HRExpenseClaimEnquiry from '../pages/ExpenseClaims/HR/HRExpenseClaimEnquiry';
import HRProcessClaimEnquiry from '../pages/ExpenseClaims/HR/HRProcessClaimEnquiry';
import EmployeeMaster from '../pages/EmployeeMaster';

const authProtectedRoutes = [
  {
    path: '/dashboard',
    component: <ProtectedRoute component={<Dashboard />} path="/dashboard" />,
  },
  {
    path: '/hr/dashboard',
    component: (
      <ProtectedRoute component={<HRDashboard />} path="/hr/dashboard" />
    ),
  },
  {
    path: '/leave/apply',
    component: (
      <ProtectedRoute component={<ApplyLeave />} path="/leave/apply" />
    ),
  },
  {
    path: '/hr/leave/apply',
    component: (
      <ProtectedRoute component={<ApplyLeave />} path="/hr/leave/apply" />
    ),
  },
  // Comp Off
  {
    path: '/comp-off/apply',
    component: (
      <ProtectedRoute component={<ApplyCompOff />} path="/comp-off/apply" />
    ),
  },
  {
    path: '/hr/comp-off/apply',
    component: (
      <ProtectedRoute component={<ApplyCompOff />} path="/hr/comp-off/apply" />
    ),
  },
  // WFH
  {
    path: '/wfh/apply',
    component: <ProtectedRoute component={<ApplyWFH />} path="/wfh/apply" />,
  },
  {
    path: '/hr/wfh/apply',
    component: <ProtectedRoute component={<ApplyWFH />} path="/hr/wfh/apply" />,
  },
  // Overtime
  {
    path: '/overtime/apply',
    component: (
      <ProtectedRoute component={<ApplyOverTime />} path="/overtime/apply" />
    ),
  },
  {
    path: '/hr/overtime/apply',
    component: (
      <ProtectedRoute component={<ApplyOverTime />} path="/hr/overtime/apply" />
    ),
  },
  // Loan
  {
    path: '/loan/apply',
    component: <ProtectedRoute component={<ApplyLoan />} path="/loan/apply" />,
  },
  {
    path: '/hr/loan/apply',
    component: (
      <ProtectedRoute component={<ApplyLoan />} path="/hr/loan/apply" />
    ),
  },
  // Bonus
  {
    path: '/bonus',
    component: <ProtectedRoute component={<Bonus />} path="/bonus" />,
  },
  // FAQ
  {
    path: '/faq',
    component: <ProtectedRoute component={<FAQ />} path="/faq" />,
  },
  // Tickets
  {
    path: '/tickets',
    component: <ProtectedRoute component={<TicketListing />} path="/tickets" />,
  },
  {
    path: '/tickets/:id',
    component: (
      <ProtectedRoute component={<TicketDetails />} path="/tickets/:id" />
    ),
  },
  {
    path: '/hr/tickets/:id',
    component: (
      <ProtectedRoute component={<TicketDetails />} path="/hr/tickets/:id" />
    ),
  },
  {
    path: '/hr/tickets',
    component: (
      <ProtectedRoute component={<HRTicketListing />} path="/hr/tickets" />
    ),
  },
  {
    path: '/hr/HRtickets/:id',
    component: (
      <ProtectedRoute
        component={<HRTicketDetails />}
        path="/hr/HRtickets/:id"
      />
    ),
  },
  {
    path: '/approvals',
    component: <ProtectedRoute component={<Approvals />} path="/approvals" />,
  },
  {
    path: '/hr/approvals',
    component: (
      <ProtectedRoute component={<Approvals />} path="/hr/approvals" />
    ),
  },
  // Timesheet
  {
    path: '/timesheet',
    component: <ProtectedRoute component={<TimeSheet />} path="/timesheet" />,
  },

  // Activity
  {
    path: '/activity',
    component: <ProtectedRoute component={<Activity />} path="/activity" />,
  },
  // Profile
  {
    path: '/profile',
    component: <ProtectedRoute component={<Profile />} path="/profile" />,
  },
  {
    path: '/hr/expense/claim',
    component: (
      <ProtectedRoute
        component={<EmployeeExpenseClaims />}
        path="/hr/expense/claim"
      />
    ),
  },
  {
    path: '/expense/claim',
    component: (
      <ProtectedRoute
        component={<EmployeeExpenseClaims />}
        path="/expense/claim"
      />
    ),
  },
  {
    path: '/expense/claim/detail',
    component: (
      <ProtectedRoute
        component={<EmployeeExpenseClaimsDetail />}
        path="/expense/claim/detail"
      />
    ),
  },
  {
    path: '/hr/expense/claim/detail',
    component: (
      <ProtectedRoute
        component={<EmployeeExpenseClaimsDetail />}
        path="/hr/expense/claim/detail"
      />
    ),
  },
  {
    path: '/hr/expense/process',
    component: (
      <ProtectedRoute
        component={<ProcessExpenseClaim />}
        path="/hr/expense/process"
      />
    ),
  },

  {
    path: '/hr/expense/process-search',
    component: (
      <ProtectedRoute
        component={<HRProcessClaimEnquiry />}
        path="/hr/expense/process-search"
      />
    ),
  },
  {
    path: '/hr/expense/enquiry',
    component: (
      <ProtectedRoute
        component={<HRExpenseClaimEnquiry />}
        path="/hr/expense/enquiry"
      />
    ),
  },
  // Enquiry
  {
    path: '/enquiry/leave',
    component: (
      <ProtectedRoute component={<LeaveEnquiry />} path="/enquiry/leave" />
    ),
  },
  {
    path: '/enquiry/overtime',
    component: (
      <ProtectedRoute
        component={<OvertimeEnquiry />}
        path="/enquiry/overtime"
      />
    ),
  },
  {
    path: '/enquiry/expense',
    component: (
      <ProtectedRoute component={<ExpenseEnquiry />} path="/enquiry/expense" />
    ),
  },
  {
    path: '/enquiry/loan',
    component: (
      <ProtectedRoute component={<LoanEnquiry />} path="/enquiry/loan" />
    ),
  },
  {
    path: '/enquiry/travel',
    component: (
      <ProtectedRoute component={<TravelEnquiry />} path="/enquiry/travel" />
    ),
  },
  {
    path: '/enquiry/wfh',
    component: (
      <ProtectedRoute component={<WFHEnquiry />} path="/enquiry/wfh" />
    ),
  },
  {
    path: '/enquiry/comp-off',
    component: (
      <ProtectedRoute component={<CompOffEnquiry />} path="/enquiry/comp-off" />
    ),
  },
  // Timesheet Enquiry
  {
    path: '/timesheet-statistics',
    component: (
      <ProtectedRoute
        component={<TimesheetStatistic />}
        path="/timesheet-statistics"
      />
    ),
  },
  // Detailed Timesheet
  {
    path: '/timesheet/:id',
    component: (
      <ProtectedRoute
        component={<DetailedTimesheet />}
        path="/timesheet/attendance"
      />
    ),
  },
  {
    path: '/hr/timesheet/:id',
    component: (
      <ProtectedRoute
        component={<DetailedTimesheet />}
        path="/hr/timesheet/:id"
      />
    ),
  },
  // Holiday
  {
    path: '/holiday/planning',
    component: (
      <ProtectedRoute component={<Planning />} path="/holiday/planning" />
    ),
  },
  {
    path: '/holiday/analysis',
    component: (
      <ProtectedRoute component={<Analysis />} path="/holiday/analysis" />
    ),
  },
  // Travel
  {
    path: '/travel-request',
    component: (
      <ProtectedRoute
        component={<PendingTravelRequest />}
        path="/travel-request"
      />
    ),
  },
  {
    path: '/travel-request/new',
    component: (
      <ProtectedRoute
        component={<NewTravelRequest />}
        path="/travel-request/new"
      />
    ),
  },
  {
    path: '/travel-request/edit/:requestNo/:revisionNo',
    component: (
      <ProtectedRoute
        component={<NewTravelRequest />}
        path="/travel-request/:requestNo/:revisionNo"
      />
    ),
  },
  {
    path: '/hr/travel-request/edit/:requestNo/:revisionNo',
    component: (
      <ProtectedRoute
        component={<NewTravelRequest />}
        path="/hr/travel-request/edit/:requestNo/:revisionNo"
      />
    ),
  },
  {
    path: '/hr/travel-request/options/:requestNo/:revisionNo',
    component: (
      <ProtectedRoute
        component={<TravelRequestOptions />}
        path="/hr/travel-request/:requestNo/:revisionNo"
      />
    ),
  },
  {
    path: '/travel-request/options/:requestNo/:revisionNo',
    component: (
      <ProtectedRoute
        component={<TravelRequestOptions />}
        path="/travel-request/:requestNo/:revisionNo"
      />
    ),
  },
  {
    path: '/travel-request/approval',
    component: (
      <ProtectedRoute
        component={<TravelRequestApproval />}
        path="/travel-request/approval"
      />
    ),
  },
  {
    path: '/hr/travel-request/approval',
    component: (
      <ProtectedRoute
        component={<TravelRequestApproval />}
        path="/hr/travel-request/approval"
      />
    ),
  },
  // Admin
  {
    path: '/admin/users',
    component: (
      <ProtectedRoute component={<UserManagement />} path="/admin/users" />
    ),
  },
  {
    path: '/admin/roles',
    component: <ProtectedRoute component={<Role />} path="/admin/roles" />,
  },
  {
    path: '/admin/application-services',
    component: (
      <ProtectedRoute
        component={<ApplicationServices />}
        path="/admin/application-services"
      />
    ),
  },
  {
    path: '/admin/encrypt-password',
    component: (
      <ProtectedRoute
        component={<EncryptPassword />}
        path="/admin/encrypt-password"
      />
    ),
  },
  {
    path: '/admin/reassign-approvals',
    component: (
      <ProtectedRoute
        component={<ReassignApprovals />}
        path="/admin/reassign-approvals"
      />
    ),
  },
  // HR Dashboard
  {
    path: '/dashboard/hr',
    component: (
      <ProtectedRoute component={<HRDashboard />} path="/dashboard/hr" />
    ),
  },
  {
    path: '/approvals/hr',
    component: (
      <ProtectedRoute component={<HRApprovals />} path="/approvals/hr" />
    ),
  },
  // HR Expense Claims
  {
    path: '/process-claim/hr',
    component: (
      <ProtectedRoute component={<ProcessClaim />} path="/process-claim/hr" />
    ),
  },
  {
    path: '/claim-enquiry/hr',
    component: (
      <ProtectedRoute component={<ClaimEnquiry />} path="/claim-enquiry/hr" />
    ),
  },
  // HR Ticketing
  {
    path: '/tickets/hr',
    component: (
      <ProtectedRoute component={<HRTicketListing />} path="/tickets/hr" />
    ),
  },
  {
    path: '/resolve-ticket/hr',
    component: (
      <ProtectedRoute
        component={<HRResolveTicket />}
        path="/resolve-ticket/hr"
      />
    ),
  },
  // HR Travel Request
  {
    path: '/hr/risk-country',
    component: (
      <ProtectedRoute component={<RiskCountry />} path="/hr/risk-country" />
    ),
  },
  {
    path: '/hr/booking-responsible',
    component: (
      <ProtectedRoute
        component={<ProcessRequest />}
        path="/hr/booking-responsible"
      />
    ),
  },
  {
    path: '/hr/travel-enquiry',
    component: (
      <ProtectedRoute
        component={<HRTravelEnquiry />}
        path="/hr/travel-enquiry"
      />
    ),
  },
  {
    path: '/hr/booking-agent',
    component: (
      <ProtectedRoute component={<BookingAgent />} path="/hr/booking-agent" />
    ),
  },
  // Performance
  {
    path: '/performance',
    component: (
      <ProtectedRoute component={<Performance />} path="/performance" />
    ),
  },
  {
    path: '/performance/:id',
    component: (
      <ProtectedRoute component={<Performance />} path="/performance/:id" />
    ),
  },
  {
    path: '/hr/performance/:id',
    component: (
      <ProtectedRoute component={<Performance />} path="/hr/performance/:id" />
    ),
  },
  {
    path: '/hr/calibration',
    component: (
      <ProtectedRoute component={<Calibration />} path="/hr/calibration" />
    ),
  },
  {
    path: '/hr/employee-performance',
    component: (
      <ProtectedRoute
        component={<EmployeePerformance />}
        path="/hr/employee-performance"
      />
    ),
  },
  {
    path: '/hr/performance-calibration/:id',
    component: (
      <ProtectedRoute
        component={<PerformanceCalibration />}
        path="/hr/performance-calibration/:id"
      />
    ),
  },

  // Employee Master
  {
    path: '/hr/employee-master',
    component: (
      <ProtectedRoute
        component={<EmployeeMaster />}
        path="/hr/employee-master"
      />
    ),
  },
  {
    path: '/employee-master',
    component: (
      <ProtectedRoute component={<EmployeeMaster />} path="/employee-master" />
    ),
  },

  // General
  { path: '/envision/', exact: true, component: <Navigate to="/dashboard" /> },
  { path: '*', component: <Navigate to="/dashboard" /> },
].filter(route => route !== null);

const publicRoutes = [
  { path: '/login', component: <Login /> },
  { path: '/login/2FA', component: <Login2FA /> },
];

export { authProtectedRoutes, publicRoutes };
